/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOrderRequest as BackendCoreApiModelsAppOrderCreateOrderRequest } from '../models/Backend/Core/Api/Models/App/Order/create-order-request';
import { OfferRequest as BackendCoreApiModelsAppOrderOfferRequest } from '../models/Backend/Core/Api/Models/App/Order/offer-request';
import { OfferResponse as BackendCoreApiModelsAppOrderOfferResponse } from '../models/Backend/Core/Api/Models/App/Order/offer-response';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class AppOrderBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createOrder
   */
  static readonly CreateOrderPath = '/api/app/offer/create-order';

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrder$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrder$Plain$Response(params: {
    body: BackendCoreApiModelsAppOrderCreateOrderRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppOrderBackendService.CreateOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrder$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrder$Plain(params: {
    body: BackendCoreApiModelsAppOrderCreateOrderRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createOrder$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrder$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrder$Json$Response(params: {
    body: BackendCoreApiModelsAppOrderCreateOrderRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppOrderBackendService.CreateOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrder$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrder$Json(params: {
    body: BackendCoreApiModelsAppOrderCreateOrderRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createOrder$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getOffers
   */
  static readonly GetOffersPath = '/api/app/offer/offers';

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffers$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getOffers$Plain$Response(params: {
    body: BackendCoreApiModelsAppOrderOfferRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppOrderBackendService.GetOffersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>;
      })
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOffers$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getOffers$Plain(params: {
    body: BackendCoreApiModelsAppOrderOfferRequest
  }): Observable<BackendCoreApiModelsAppOrderOfferResponse> {

    return this.getOffers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>) => r.body as BackendCoreApiModelsAppOrderOfferResponse)
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffers$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getOffers$Json$Response(params: {
    body: BackendCoreApiModelsAppOrderOfferRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppOrderBackendService.GetOffersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>;
      })
    );
  }

  /**
   * Gets offers by type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOffers$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getOffers$Json(params: {
    body: BackendCoreApiModelsAppOrderOfferRequest
  }): Observable<BackendCoreApiModelsAppOrderOfferResponse> {

    return this.getOffers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppOrderOfferResponse>) => r.body as BackendCoreApiModelsAppOrderOfferResponse)
    );
  }

}
